var exports = {
  "q": "footer__cQhmlc",
};

module.exports = exports;
